import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterItems, beforeItems } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function BeforeAfter() {
  return <section className="bg-cream-100 px-5 py-16 md:py-24" data-id="element-79" data-mp="26luonyxbie5l">
      <div className="mx-auto max-w-5xl" data-id="element-80" data-mp="26k9tc736ir6o">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-3xl font-bold leading-tight text-navy-950 md:text-5xl" data-id="element-81" data-mp="22lkaw03aajg6">
          From analyzing every case differently… <em className="text-gold-700" data-id="element-82" data-mp="2z8ntasdtvxkv">to having a structured system.</em>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-83" data-mp="2u9uk3c5kqsqi">
          <div className="rounded-3xl bg-white p-6 ring-1 ring-red-200 md:p-8" data-id="element-84" data-mp="2q9ahht28ewwz">
            <div className="flex items-center gap-3" data-id="element-85" data-mp="2lc20hvstkyxb">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-86" data-mp="2ldd33saj40mu">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-87" data-mp="19w3lzcevhkop" />
              </span>
              <h3 className="text-xl font-extrabold uppercase tracking-wide text-red-600" data-id="element-88" data-mp="175cn458rchk4">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-89" data-mp="1c4z0qfshzztg">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-relaxed text-muted" data-id="element-90" data-mp="y4xzv0c8gsdz">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-91" data-mp="133r6c8t3rj4n" />
                  <span data-id="element-92" data-mp="oeux48fb802g">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy-900 p-6 ring-2 ring-gold-500 md:p-8" data-id="element-93" data-mp="t5l5luj18j1d">
            <div className="flex items-center gap-3" data-id="element-94" data-mp="t7fqj8ub0b5g">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold-400 text-navy-950" data-id="element-95" data-mp="ffhmhcfg95g5">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="jgb7ny1ic65c" />
              </span>
              <h3 className="text-xl font-extrabold uppercase tracking-wide text-gold-400" data-id="element-97" data-mp="5gsecbdcuzd3">After — with MasterMap™</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-98" data-mp="2c49aso80h3jy">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-relaxed text-white" data-id="element-99" data-mp="2c63rtrg5wbir">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-400" strokeWidth={3} aria-hidden="true" data-id="element-100" data-mp="27bpsxf2ajm9c" />
                  <span data-id="element-101" data-mp="1yd4g80ji31gh">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <CtaButton className="mt-12" label="I want to analyze with a system" data-id="element-102" data-mp="2v3n371q3e68c" />
      </div>
    </section>;
}